export const BOOKING = {
  STATUS: {
    ACTIVE: 'active',
    EXPIRED: 'expired',
    CANCELED: 'canceled'
  },
  LIMIT_MONTHS: 6
}

export const PageSection = { Hotel: 'hotel', Mobility: 'mobility', Experience: 'experience' }

export const TABS = [PageSection.Hotel, PageSection.Mobility, PageSection.Experience]

export const tiers = {
  'Tiering.upgrade.to.silver.rule': 'silver',
  'Tiering.upgrade.to.gold.rule': 'gold',
  'Tiering.upgrade.to.platinum.rule': 'platinum',
  'Tiering.upgrade.to.diamond.rule': 'diamond'
}

export type TierUpgrade = keyof typeof tiers

export enum GIFT_NAME_ENUM {
  DRINK = 'DRINK'
}

export enum BOOKING_STATUS_ENUM {
  CANCELLED = 'CANCELLED'
}

export enum HotelBookingOriginType {
  TARS = 'TARS',
  ACRS = 'ACRS'
}
